import styles from './header.module.scss';
import { useAppData } from '~/components/AppData';
import { EnvironmentTypes } from '~/api';
import { lazy, Show } from 'solid-js';
import WorkspaceInProductBanner from '~/components/Layout/Header/WorkspaceInProductBanner.tsx';
import { shouldShowInProductBanner } from '~/components/Layout/Header/utils.ts';
import { isEnvHospedContext, isWorkspaceContext } from '~/utils/commonUtils.ts';

export default function Header() {
  const appData = useAppData();

  const getHeaderComponent = () => {
    if (isWorkspaceContext()) {
      return lazy(() => import('~/components/Layout/Header/WorkspaceHeader'));
    } else if (isEnvHospedContext()) {
      return lazy(() => import('~/components/Layout/Header/EnvAppPagesHeader'));
    }
    return () => <></>;
  };

  const HeaderComponent = getHeaderComponent();

  // adjust top nav height for env-hosed apps
  // since the environment borders are not there
  if (isEnvHospedContext()) {
    document.documentElement.style.setProperty('--top-nav-height', `57px`);
  }

  return (
    <>
      <Show when={isWorkspaceContext()}>
        <WorkspaceInProductBanner />
      </Show>
      <header
        class={`${styles.topNavbar}`}
        classList={{
          'border-b-yellow-500':
            isWorkspaceContext() &&
            appData?.selectedEnvironment?.type !== EnvironmentTypes.PRODUCTION,
          'border-b-green-600':
            isWorkspaceContext() && appData.selectedEnvironment?.type === EnvironmentTypes.PRODUCTION,
          [styles.pushBelowInproductBanner]: isWorkspaceContext() &&
            appData && shouldShowInProductBanner({
            workspace: appData.workspace!,
            environment: appData.selectedEnvironment!
          })
        }}
      >
        <HeaderComponent />
      </header>
    </>
  );
}
